import Help from '../view/Help'
import NewsPublicCard from '../view/NewsPublicCard'
export const routes = [
  {
    path: '/help',
    name: 'Help',
    component: Help
  },
  {
    path: '/help/news/:id',
    name: 'NewsPublicCard',
    component: NewsPublicCard
  },
]